<h2 mat-dialog-title>Help</h2>

<!-- If Doctor or Admin, show instructions -->
<mat-dialog-content>
  <p>Click any of the tutorial buttons below to watch a tutorial video
    <span *ngIf="isDoctor || isAdmin"> or restart the tutorial</span>
  </p>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <ng-container *ngFor="let tutorial of tutorials">
    <button mat-raised-button color="primary" (click)="openVideoDialog(tutorial.url)">
      {{tutorial.label}}
    </button>
  </ng-container>
  <!--Restart Tutorial Button -->
  <!-- <button mat-raised-button color="warn" *ngIf="isDoctor || isAdmin" (click)="restartTutorial()">
    Restart Tutorial
  </button> -->
  <!-- WhatsApp Support -->
  <button mat-raised-button class="whatsapp-support-btn" (click)="openWhatsAppSupport()"
    [disabled]="!user || !group || openingWhatsAppSupport">
    <mat-icon svgIcon="whatsapp"></mat-icon> WhatsApp Support
  </button>
  <!-- In-app support (M7): the same MedicAI Support team, in the chat window; WhatsApp stays -->
  <button *ngIf="(chatEnabled$ | async) !== false" mat-raised-button color="primary" class="in-app-support-btn"
    (click)="openInAppSupport()" [disabled]="!group || openingInAppSupport">
    <mat-icon>support_agent</mat-icon> Chat with Support
  </button>
</mat-dialog-actions>

<!-- Always show cancel button -->
<mat-dialog-actions align="center">
  <button mat-stroked-button (click)="forceRefresh()" [disabled]="refreshing">
    <mat-icon>refresh</mat-icon> Force Refresh
  </button>
  <button mat-button color="warn" (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>